import { Card, CardContent, CardHeader, Chip } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import ServerSide from 'examples/Tables/TabelKomponen/ServerSide'
import { CustomDescrypt } from 'global/func'
import { postDataWithResponse } from 'global/postFunc'
import React, { useEffect, useMemo, useState } from 'react'
import { Route, Routes } from 'react-router-dom'
import userStore from 'store/userStore'
import Komponen from '../Laporan/Komponen'

const ProjekStrategis = () => {
    return (
        <Routes>
            <Route path="" element={<Data />} />
            <Route path="komponen" element={<Komponen />} />
        </Routes>
    )
}

const Data = () => {
    const { user, addReq, tahunAnggaran } = userStore(state => ({ user: state.user, addReq: state.addReq, tahunAnggaran: state.tahunAnggaran }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const date = new Date();
    const bulan = date.getMonth()

    const [listOpd, setListOpd] = useState([])
    const [listOpd2, setListOpd2] = useState([])

    useEffect(() => {
        setListOpd2([])
        listOpd.forEach((opdx) => {
            let data = { label: opdx.nama_pd, value: opdx.kd_pd }
            setListOpd2(listOpd2 => [...listOpd2, data])
        })
        console.log(listOpd2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listOpd])

    const reqOpd = () => {
        setLoading(true)
        postDataWithResponse(
            '/opd/filter',
            {
                jenis: '',
                nama: '',
            },
            null,
            (res) => {
                console.log(res);
                setListOpd(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    useEffect(() => {
        reqOpd()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10, //customize the default page size
    });
    // const [globalFilter, setGlobalFilter] = useState('')
    const [columnFilter, setColumnFilter] = useState([])
    const [sorting, setSorting] = useState([])

    useEffect(() => { console.log(columnFilter); }, [columnFilter])

    const reqBelanja = () => {
        addReq()
        setLoading(true)
        postDataWithResponse(
            '/sa/paket-pekerjaan/projek-strategis',
            {
                ta: tahunAnggaran.ta,
                pagination: pagination,
                // globalFilter: globalFilter,
                sorting: sorting,
                columnFilter: columnFilter
            },
            decryptedUser,
            (res) => {
                console.log(res);
                setData(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    useEffect(() => {
        reqBelanja()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pagination,
        // globalFilter,
        sorting,
        columnFilter
    ])

    const columns = useMemo(() => ([
        {
            accessorKey: null,
            header: '#',
            size: 5,
            Cell: ({ cell }) => (
                <>
                    <ArgonTypography
                        fontSize="small"
                        variant="inherit"
                    >
                        {(pagination.pageIndex * pagination.pageSize) + cell.row.index + 1}
                    </ArgonTypography>
                </>
            )
        },
        {
            accessorKey: 'kd_pd',
            header: 'OPD',
            size: 100,
            maxSize: 100,
            grow: false,
            Cell: ({ cell }) => (
                <>
                    <ArgonTypography
                        fontSize="small"
                        fontWeight="bold"
                        variant="inherit"
                    >
                        {cell.getValue()}
                    </ArgonTypography>
                    <ArgonTypography
                        fontSize="small"
                        variant="inherit"
                    >
                        {cell.row.original.opd.nama_pd}
                    </ArgonTypography>
                </>
            ),
            filterSelectOptions: listOpd2,
            filterVariant: 'select',
        },
        {
            accessorKey: 'nama_komponen',
            header: 'Komponen',
            muiSearchTextFieldProps: {
                placeholder: 'Search all users',
                sx: { with: '3px' },
                variant: 'outlined',
            },
            Cell: ({ cell }) => (
                <>
                    <ArgonTypography
                        fontSize="small"
                        variant="inherit"
                    >
                        {cell.getValue()}
                    </ArgonTypography>
                    <Chip
                        size='small'
                        variant='outlined'
                        label={
                            cell.row.original.laporan_terakhir === null ? "Realisasi belum dilaporkan" : "Laporan Terakhir Bulan " + cell.row.original.laporan_terakhir
                        } color={
                            cell.row.original.status_pelaksanaan === 'Selesai' ? 'success' : (parseInt(cell.row.original.laporan_terakhir) < bulan || cell.row.original.laporan_terakhir === null) ? 'error' : 'success'
                        }
                    />
                </>
            )
        },
        {
            accessorKey: 'anggaran',
            header: 'Anggaran',
            Cell: ({ cell }) => (
                <ArgonTypography
                    variant="inherit"
                    fontSize="small"
                >
                    {
                        parseInt(cell.getValue())?.toLocaleString?.('id-ID', {
                            style: 'currency',
                            currency: 'IDR',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        })
                    }
                </ArgonTypography>
            )
        },
        {
            accessorKey: 'uraian_sumber_dana',
            header: 'Sumber Dana',
            Cell: ({ cell }) => (
                <ArgonTypography
                    variant="inherit"
                    fontSize="small"
                >
                    {cell.getValue()}
                </ArgonTypography>
            ),
            // filterSelectOptions: [
            //     { label: 'DAK FISIK', value: 'Dana Alokasi Khusus Fisik' },
            //     { label: 'DAK NON FISIK', value: 'Dana Alokasi Khusus Non Fisik' },
            // ],
            // filterVariant: 'select',
        },
        {
            accessorKey: 'status_pelaksanaan',
            header: 'Progres',
            Cell: ({ cell }) => (
                <Chip
                    size="small"
                    variant='outlined'
                    color={cell.getValue() === "Belum Terlaksana" ? "error" : cell.getValue() === "Selesai" ? "success" : 'info'}
                    label={cell.getValue()}
                />
            ),
            filterSelectOptions: [
                { label: 'Belum Terlaksana', value: 'Belum Terlaksana' },
                { label: 'Persiapan', value: 'Persiapan' },
                { label: 'Pelaksanaan', value: 'Pelaksanaan' },
                { label: 'Selesai', value: 'Selesai' },
            ],
            filterVariant: 'select',
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
    ]), [data, pagination])

    const columnVisibility= {
        uraian_sumber_dana: false,
    }

    return (
        <ArgonBox pt={3} pb={5}>
            <ArgonBox mb={3}>
                <Card>
                    <CardHeader
                        title={
                            <ArgonTypography variant='h6'>Projek Strategis</ArgonTypography>
                        }
                    />
                    <CardContent>
                        <ArgonBox mb={3}>
                            <ServerSide
                                loading={loading}
                                data={data.data}
                                columns={columns}
                                rowCount={data.rowCount}
                                baseUrl="/admin/projek-strategis"
                                pagination={pagination}
                                setPagination={setPagination}
                                // globalFilter={globalFilter}
                                // setGlobalFilter={setGlobalFilter}
                                sorting={sorting}
                                setSorting={setSorting}
                                columnFilter={columnFilter}
                                setColumnFilter={setColumnFilter}
                                columnVisibility={columnVisibility}
                            />
                        </ArgonBox>
                    </CardContent>
                </Card>
            </ArgonBox>
        </ArgonBox>
    )
}

export default ProjekStrategis